module.exports = __webpack_public_path__ + "img/11m.37e5a5f7.png";